<template>
    <div>
        <button v-if="media" class="btn btn-success" @click="downloadFile">
            <i class="fas fas fa-download" /> {{ media.name }}
        </button>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        mediaId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            media: null
        };
    },

    async created() {
        try {
            this.media = await this.getMedia(this.mediaId);
        } catch (error) {
            console.error(error);
        }
    },

    methods: {
        ...mapActions({
            getMedia: 'media/show'
        }),

        downloadFile() {
            this.$downloadFile(this.$getFileUrl(this.media), this.media.name);
        }
    }
};
</script>
